import { z } from "zod";
import { TERM_NAME, DESCRIPTION, DAYS, PERCENT } from "./consts";

export const schema = z.object({
  [TERM_NAME]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
  [DAYS]: z.string().min(1, "This field is required"),
  [PERCENT]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
